<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ "campaign.saveConfirmModal.title" | translate }}
        </h4>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="cancel()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="list-group list-group-flush">
          <div class="list-group-item">
            @if (campaign?.metadata.templateName) {
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span class="text-muted">{{
                  "campaign.saveConfirmModal.template" | translate
                }}</span>
                <span class="fw-semibold text-dark">
                  {{ campaign?.metadata.templateName }}
                </span>
              </div>
            }
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted">{{
                "campaign.saveConfirmModal.audience" | translate
              }}</span>
              <span class="fw-semibold text-dark">
                {{ audience }}
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted">{{
                "campaign.campaignForm.totalToSend" | translate
              }}</span>
              <span class="fw-semibold text-dark">
                {{
                  totalToSend === null ? "—" : (totalToSend | number: "1.0-0")
                }}
              </span>
            </div>

            @if (totalToSend === null) {
              <div class="alert alert-warning py-1 px-2 mb-2 small">
                {{ "campaign.campaignForm.summaryUnavailable" | translate }}
              </div>
            } @else if (totalToSend === 0) {
              <div class="alert alert-warning py-1 px-2 mb-2 small">
                {{ "campaign.campaignForm.summaryReachesNobody" | translate }}
              </div>
            }

            @if (ignoredTags?.length > 0) {
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span class="text-muted">{{
                  "campaign.saveConfirmModal.ignoredTags" | translate
                }}</span>
                <span class="fw-semibold text-dark">
                  {{ ignoredTags.length }}
                </span>
              </div>
            }
            @if (ignoredContactGroups?.length > 0) {
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span class="text-muted">{{
                  "campaign.saveConfirmModal.ignoredContactGroups" | translate
                }}</span>
                <span class="fw-semibold text-dark">
                  {{ ignoredContactGroups.length }}
                </span>
              </div>
            }

            @if (data.channel.type === "CLOUD_API") {
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span class="text-muted">{{
                  "campaign.saveConfirmModal.expectedCost" | translate
                }}</span>
                <span class="fw-semibold text-dark">
                  @if (unpriced) {
                    <span class="text-muted fw-normal">{{
                      unpricedLabel | translate
                    }}</span>
                  } @else {
                    {{ cost ?? 0 | currency: priceCurrency : "symbol" : "1.2-2" }}
                  }
                </span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-light"
          (click)="cancel()"
          [matDialogClose]="false"
        >
          {{ "campaign.saveConfirmModal.cancel" | translate }}
        </button>
        <button
          [hidden]="cannotConfirm"
          type="button"
          class="btn btn-primary"
          (click)="confirmSaveCampaign()"
          [matDialogClose]="false"
        >
          {{ "campaign.saveConfirmModal.confirm" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
